import { defaultGrid } from "../../helpers/datagrid";

const initialState = { 
	grid: {...defaultGrid.grid},
	summary: {...defaultGrid.grid},
	pageCount: 1
}


export default (state = initialState, action) => {
	switch (action.type) {
		case 'FETCH_SESSIONS_BY_COMPANY':
			return {...state, ...action.payload};
		default:
			return state;
	}
};
